import { COLOR_PALETTE } from 'constants/ui';

export const cardContainerStyles = {
  backgroundColor: COLOR_PALETTE.BLUE[1],
  borderRadius: '4px 8px 8px 4px',
  padding: '16px 16px 16px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  position: 'relative',
  boxShadow: ({ palette }) => palette.shadow?.s ?? '0px 1px 4px 0px rgba(18, 23, 29, 0.15)',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '4px',
    backgroundColor: COLOR_PALETTE.BLUE[6],
    borderRadius: '4px 0 0 4px',
  },
};

export const progressContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const progressTextStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const progressBarStyles = {
  borderRadius: '4px',
  height: '4px',
};

export const questionContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const questionHeaderStyles = {
  color: COLOR_PALETTE.BLUE[7],
};

export const questionTextStyles = {
  color: ({ palette }) => palette.text.dark,
  wordBreak: 'break-word',
};

export const optionsContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const optionLabelStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const optionDescriptionStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const trailContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  paddingBottom: '8px',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
};

export const trailTitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const trailItemStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
};

export const trailItemTextStyles = {
  color: ({ palette }) => palette.text.dark,
  wordBreak: 'break-word',
  flex: 1,
  minWidth: 0,
};

export const trailEditButtonStyles = {
  padding: 0,
  minWidth: 'auto',
  flexShrink: 0,
};

export const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '4px',
};

export const footerSpacerStyles = {
  flex: 1,
};
